// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--kvg8V";
export var pagination = "index-module--pagination--Jcv5N";